// extracted by mini-css-extract-plugin
export default {"tooltipPremiumPlan":"TooltipPremiumPlan_tooltipPremiumPlan__D-deD","subtitle":"TooltipPremiumPlan_subtitle__ksetd","img":"TooltipPremiumPlan_img__FJxzd"};